import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  httpCallsNb: number;
  loadingProgress: BehaviorSubject<number>;

  constructor() {
    this.httpCallsNb = 0;
    this.loadingProgress = new BehaviorSubject<number>(100);
   }

   private update(){
    this.loadingProgress.next(100 - this.httpCallsNb*10);
   }

   public addHttpCall(){
     this.httpCallsNb++;
     this.update();
   }

   public removeHttpCall(){
     this.httpCallsNb --;
     this.update();
   }
}
